var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserSession(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "black",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4545 35.9091C45.4545 38.9216 43.0125 41.3636 40 41.3636C36.9875 41.3636 34.5455 38.9216 34.5455 35.9091C34.5455 32.8966 36.9875 30.4545 40 30.4545C43.0125 30.4545 45.4545 32.8966 45.4545 35.9091ZM42.7273 35.9091C42.7273 37.4153 41.5062 38.6364 40 38.6364C38.4938 38.6364 37.2727 37.4153 37.2727 35.9091C37.2727 34.4029 38.4938 33.1818 40 33.1818C41.5062 33.1818 42.7273 34.4029 42.7273 35.9091Z",
    fill: "#CF0F6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 25C31.7157 25 25 31.7157 25 40C25 48.2843 31.7157 55 40 55C48.2843 55 55 48.2843 55 40C55 31.7157 48.2843 25 40 25ZM27.7273 40C27.7273 42.8503 28.6989 45.4736 30.3291 47.5569C32.5715 44.6212 36.1085 42.7273 40.0879 42.7273C44.0157 42.7273 47.5125 44.5724 49.7589 47.4431C51.336 45.3785 52.2727 42.7987 52.2727 40C52.2727 33.222 46.778 27.7273 40 27.7273C33.222 27.7273 27.7273 33.222 27.7273 40ZM40 52.2727C37.0679 52.2727 34.3759 51.2445 32.265 49.5289C33.9912 47.0653 36.8514 45.4545 40.0879 45.4545C43.2842 45.4545 46.1136 47.0256 47.8461 49.4375C45.7189 51.2079 42.9838 52.2727 40 52.2727Z",
    fill: "#CF0F6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSession);
export default __webpack_public_path__ + "static/media/userSession.4bf37f88.svg";
export { ForwardRef as ReactComponent };